import LoginButton from '../components/LoginButton/LoginButton';

const SignIn = () => (
  <div className="d-flex justify-content-center mt-2">
    <LoginButton />
  </div>
);

export default SignIn;
